import React from 'react';
import TransLabel from '../../../../common/TransLabel';
import ButtonDelete from './ButtonDelete';

/** ****************************
 * HELPERS
 */

const EMPTY_OBJECT = {};
const DEFAULT_HEADER = '';
const PROP_KEY = 'none';

/** ****************************
 * MAIN
 */

const TH = ({ header = DEFAULT_HEADER }) => <TransLabel text={header} abbrv />;

const TD = ({ item = EMPTY_OBJECT }) => {
	return (
		<td className="td-col-ACTIONS">
			<ButtonDelete item={item} />
		</td>
	);
};

const ColActions = { TH, TD, CSV_PROP: PROP_KEY, DEFAULT_HEADER };

export default ColActions;
